var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28126 12C9.28126 12.6962 9.55783 13.3639 10.0501 13.8562C10.5424 14.3484 11.2101 14.625 11.9063 14.625C12.6025 14.625 13.2701 14.3484 13.7624 13.8562C14.2547 13.3639 14.5313 12.6962 14.5313 12C14.5313 11.3038 14.2547 10.6361 13.7624 10.1438C13.2701 9.65156 12.6025 9.375 11.9063 9.375C11.2101 9.375 10.5424 9.65156 10.0501 10.1438C9.55783 10.6361 9.28126 11.3038 9.28126 12ZM22.0828 11.3953C19.861 6.71484 16.5024 4.35938 12 4.35938C7.49533 4.35938 4.13908 6.71484 1.9172 11.3977C1.82808 11.5864 1.78186 11.7925 1.78186 12.0012C1.78186 12.2099 1.82808 12.416 1.9172 12.6047C4.13908 17.2852 7.49767 19.6406 12 19.6406C16.5047 19.6406 19.861 17.2852 22.0828 12.6023C22.2633 12.2227 22.2633 11.782 22.0828 11.3953ZM11.9063 16.125C9.62814 16.125 7.78126 14.2781 7.78126 12C7.78126 9.72188 9.62814 7.875 11.9063 7.875C14.1844 7.875 16.0313 9.72188 16.0313 12C16.0313 14.2781 14.1844 16.125 11.9063 16.125Z",
    fill: "#718096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21L3 3Z",
    fill: "#718096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L20 20L3 3Z",
    fill: "#718096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L20 20",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.41f94de9e4f66330442efc838feaa713.svg";
export { ForwardRef as ReactComponent };